var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":_vm.imgConfig[_vm.namespace]}}),_c('div',{staticClass:"service",on:{"click":_vm.serviceCenter}},[_c('svg-icon',{attrs:{"iconClass":"bj-service-by"}}),_vm._v("客服中心 ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }